import { useRouterState } from "@tanstack/react-router";
import { AnimatePresence, motion } from "framer-motion";

export function PathBar() {
  const { location } = useRouterState();
  const path = location.pathname === "/" ? "/home" : location.pathname;

  return (
    <div className="flex items-center gap-2 font-mono text-sm">
      <span className="text-primary">$</span>
      <AnimatePresence mode="wait">
        <motion.span
          key={path}
          initial={{ opacity: 0, y: -6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 6 }}
          transition={{ duration: 0.15 }}
          className="text-text"
        >
          console<span className="text-muted">{path}</span>
        </motion.span>
      </AnimatePresence>
      <span className="w-2 h-4 bg-primary/80 inline-block animate-pulse-led ml-1" />
    </div>
  );
}
